import React from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const RichTextEditor = ({ value, onChange }) => {
  const eventListenerOptions = { passive: false };

  return (
    <div style={{ minHeight: 200 }}>
      <SunEditor
        height="200px"
        setContents={value || ""}
        onChange={content => {
          onChange(content);  // notify AntD form of value change
        }}
        placeholder="Please Enter Body"
        setOptions={{
          buttonList: [
            ["undo", "redo"],
            ["font", "fontSize", "formatBlock"],
            ["paragraphStyle", "blockquote"],
            ["bold", "underline", "italic", "strike", "subscript", "superscript"],
            ["fontColor", "hiliteColor", "textStyle"],
            ["removeFormat"],
            "/",
            ["outdent", "indent"],
            ["align", "horizontalRule", "list", "lineHeight"],
            ["table", "link"],
            ["horizontalRule", "image", "video", "template"],
          ],
        }}
        eventListenerOptions={eventListenerOptions}
      />
    </div>
  );
};

export default RichTextEditor;
